export const SHOW_SNACK = "SHOW_SNACK";
export const HIDE_SNACK = "HIDE_SNACK";
export const START_FETCHING = "START_FETCHING";
export const END_FETCHING = "END_FETCHING";
export const END_OFFLINE = "END_OFFLINE";
export const START_OFFLINE = "START_OFFLINE";
